import { useNavigate } from "react-router-dom";
import { MeterBar } from "@/components/ui/MeterBar";
import { formatCount } from "@/lib/format";
import type { TopStrategy } from "@/features/dashboard/api";

export function StrategyMiniCard({ strategy }: { strategy: TopStrategy }) {
  const navigate = useNavigate();

  return (
    <div
      className="strategy-mini-card strategy-mini-card-clickable"
      role="link"
      tabIndex={0}
      onClick={() => navigate("/strategies")}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          navigate("/strategies");
        }
      }}
    >
      <span className="strategy-mini-card-name">{strategy.strategy_name}</span>
      <MeterBar value={strategy.win_rate} />
      <span className="text-muted font-numeric strategy-mini-card-count">
        {formatCount(strategy.total_signals)} signals
      </span>
    </div>
  );
}
